<template>
  <b-card title="Beyaz Logo">
    <div
      v-if="dataItem.logo_white"
      class="d-flex justify-content-center"
    >
      <div class="rounded text-center mb-2 p-2 border border-1">
        <div class="border border-1 p-3 rounded">
          <b-img
            :src="dataItem.logo_white"
            fluid
          />
        </div>
        <b-button
          class="mt-1"
          variant="secondary"
          size="sm"
          block
          :href="dataItem.logo_white"
          target="_blank"
        >
          <FeatherIcon icon="DownloadIcon" />
          Görüntüle
        </b-button>
        <b-button
          block
          class="mt-1"
          variant="flat-danger"
          size="sm"
          @click="removeFile(dataItem.logo_white_id)"
        >
          <FeatherIcon icon="TrashIcon" />
          Dosyayı Sil
        </b-button>
      </div>
    </div>
    <div
      v-else
      class="text-center mt-1"
    >
      <div class="bordered bg-light p-2 rounded mb-2 text-muted">
        <div>
          <div><FeatherIcon icon="InfoIcon" /></div>
          <div>Restoran Logosu Bulunamadı.</div>
        </div>
      </div>
      <b-alert
        variant="danger"
        show
      >
        <div class="alert-body">
          <div class="font-small-2">
            Önerilen format: PNG, SVG
          </div>
          <div class="font-small-2">
            Koyu renkli zeminlerde kullanılır.
          </div>
        </div>
      </b-alert>
      <b-button
        variant="primary"
        block
        @click="setModal"
      >
        <FeatherIcon icon="UploadIcon" />
        Logo Yükle
      </b-button>
    </div>
    <docs-upload
      v-if="uploadSettings.modalStatus"
      :modal-status="uploadSettings.modalStatus"
      :close-modal="closeModal"
      :folder="uploadSettings.folder"
      component="branches"
      :item-id="dataItem.id"
      params="white"
      @uploadFile="setUploadFile"
    />
  </b-card>
</template>

<script>
import {
  BButton, BCard, BImg, BAlert,
} from 'bootstrap-vue'
import DocsUpload from '@/layouts/components/common/DocsUpload.vue'

export default {
  name: 'LogoUpload',
  components: {
    BCard,
    BButton,
    BImg,
    BAlert,
    DocsUpload,
  },
  data() {
    return {
      fileUrl: this.$store.state.app.baseURL,
      uploadSettings: {
        modalStatus: false,
        folder: null,
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['branches/dataItem']
    },
  },
  methods: {
    setModal() {
      this.uploadSettings = {
        modalStatus: true,
        folder: 'branches',
      }
    },
    closeModal() {
      this.uploadSettings = {
        modalStatus: false,
        folder: null,
      }
    },
    removeFile(id) {
      this.$store.dispatch('fileUpload/removeData', id)
        .then(response => {
          if (response.status) {
            this.dataItem.logo_white = null
            this.dataItem.logo_white_id = null
            this.dataItem.whiteFileData = null
          }
        })
    },
    setUploadFile(item) {
      this.dataItem.logo_white = item.filename
      this.dataItem.logo_white_id = item.id
      this.dataItem.whiteFileData = item
      this.uploadSettings.modalStatus = false
    },
  },
}
</script>
